/* eslint-disable react-hooks/exhaustive-deps */
import { Common } from '@stockbit/ui';
import { useEffect } from 'react';
import { notificationTabsAttrs } from 'utils/notification';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';

import NotificationTitle from './NotificationTitle';
import NotificationTab from './NotificationTab';
import { CloseButton, LineLoader } from './styled';

const { Flex, PopoverTitleWrapper, Text } = Common;

interface NotificationHeaderProps {
  device?: string;
  close?: () => void;
}

function NotificationHeader({ device }: NotificationHeaderProps) {
  const tab = useNotificationData((store) => store.tab);
  const unread = useNotificationData((store) => store.unread);
  const isLoading = useNotificationData((store) => store.isLoading);

  const closePopup = useNotificationData((store) => store.closePopup);
  const changeTab = useNotificationData((store) => store.changeTab);
  const markNotifAsRead = useNotificationData((store) => store.markNotifAsRead);

  useEffect(() => {
    if (unread > 0) {
      markNotifAsRead(tab);
    }
  }, [unread]);

  const isMobileDevice = device === 'mobile';

  return (
    <>
      <LineLoader isLoading={isLoading} />
      <PopoverTitleWrapper>
        <Flex align="center" justify="space-between" width="100%">
          <NotificationTitle
            tab={tab}
            onClickBack={() => changeTab('notification')}
          />
          <Text mr="20px" style={{ display: isLoading ? 'block' : 'none' }}>
            Please Wait ...
          </Text>
        </Flex>
        <Flex>
          {!isMobileDevice && (
            <NotificationTab list={notificationTabsAttrs} type="icon" />
          )}
          {isMobileDevice && (
            <CloseButton onClick={closePopup}>Close</CloseButton>
          )}
        </Flex>
      </PopoverTitleWrapper>
      {isMobileDevice && (
        <Flex align="center" justify="center">
          <NotificationTab list={notificationTabsAttrs} type="text" />
        </Flex>
      )}
    </>
  );
}

export default NotificationHeader;
